import { AgencyTypeId } from '@app/models';
import { ValidityPeriod, validityPeriodDetailed } from '@app/pcs/models';
import {
  pathElementsSchema,
  PathSection,
  variantSectionDetailed,
  variantSectionWithCalendars,
  variantSectionWithoutTrainParameters,
  variantSectionWithTrainParameters
} from '@dossier/models/path-section';
import { processStrategyForParent } from '@dossier/models/schema-process-strategy';
import { gql } from 'apollo-angular';
import { schema } from 'normalizr';

interface BasePath {
  id?: number;
  sortOrder?: number;
  agencyTypeId?: AgencyTypeId;
  pathTitle?: string;
  serviceDaysForReferencePoint?: string;
  tsiVariantId?: string;
  validityPeriod?: ValidityPeriod;
}

export interface PathWithBlocks extends BasePath {
  pathSectionBlocks: PathSection[][];
}

export interface Path extends BasePath {
  pathElements: PathSection[];
}

export const applicantPathSchema = new schema.Entity('applicantPath', {
  pathElements: [pathElementsSchema]
}, {
  idAttribute: 'id',
  processStrategy: processStrategyForParent
});

export const dossierDraftApplicantPath = gql`
  fragment applicantPath on ApplicantPath {
    agencyTypeId {
      id
      description
    }
    pathTitle
    serviceDaysForReferencePoint
    tsiVariantId
    validityPeriod {
      ...validityPeriodDetailed
    }
    pathElements {
      ...variantSectionWithTrainParameters
    }
  }
  ${validityPeriodDetailed}
  ${variantSectionWithTrainParameters}
`;

export const dossierDraftApplicantPathWithoutTrainParameters = gql`
  fragment applicantPathWithoutTrainParameters on ApplicantPath {
    agencyTypeId {
      id
      description
    }
    pathTitle
    serviceDaysForReferencePoint
    tsiVariantId
    validityPeriod {
      ...validityPeriodDetailed
    }
    pathElements {
      ...variantSectionWithoutTrainParameters
    }
  }
  ${validityPeriodDetailed}
  ${variantSectionWithoutTrainParameters}
`;

export const dossierDraftApplicantPathWithCalendars = gql`
  fragment applicantPathWithCalendars on ApplicantPath {
    agencyTypeId {
      id
      description
    }
    pathTitle
    serviceDaysForReferencePoint
    tsiVariantId
    validityPeriod {
      ...validityPeriodDetailed
    }
    pathElements {
      ...variantSectionWithCalendars
    }
  }
  ${validityPeriodDetailed}
  ${variantSectionWithCalendars}
`;

export const applicantPathDetailed = gql`
  fragment applicantPathDetailed on ApplicantPath {
    agencyTypeId {
      id
      description
    }
    pathTitle
    serviceDaysForReferencePoint
    tsiVariantId
    validityPeriod {
      ...validityPeriodDetailed
    }
    pathElements {
      ...variantSectionDetailed
    }
  }
  ${validityPeriodDetailed}
  ${variantSectionDetailed}
`;
